export const ReportKey = {
    balance_sheet: '/reports/balance-sheet',
    profit_loss: '/reports/profit-loss',
    cash_flow: '/reports/cash-flow',
    trial_balance: '/reports/trial-balance',
    aged_receivables_summary: '/reports/aged-receivables/summary',
    aged_payables_summary: '/reports/aged-payables/summary',
    aged_receivables_detail: '/reports/aged-receivables/detail',
    aged_payables_detail: '/reports/aged-payables/detail',
    product_sales_summary: '/reports/product-sales/summary',
    product_sales_detail: '/reports/product-sales/detail',
    product_bundle_sales_summary: '/reports/product-bundle-sales/summary',
    product_purchases_summary: '/reports/product-purchases/summary',
    product_purchases_detail: '/reports/product-purchases/detail',
    item_sales_collection: '/reports/item-sales-collection',
    tag_sales_summary: '/reports/tag-sales/summary',
    customer_sales_summary: '/reports/customer-sales/summary',
    general_ledger: '/reports/general-ledger',
    debtor_ledger: '/reports/debtor-ledger',
    creditor_ledger: '/reports/creditor-ledger',
    invoice_summary: '/reports/invoice-summary',
    credit_note_summary: '/reports/credit-note-summary',
    purchase_credit_note_summary: '/reports/purchase-credit-note-summary',
    payment_summary: '/reports/payment-summary',
    purchase_payment_summary: '/reports/purchase-payment-summary',
    bill_summary: '/reports/bill-summary',
    bank_reconciliation: '/reports/bank-reconciliation',
    reconciled_transactions: '/reports/reconciled-transactions',
    inventory_summary: '/reports/inventory/summary',
    inventory_detail: '/reports/inventory/detail',
    inventory_summary_by_location: '/reports/inventory-summary-by-location',
    profit_summary: '/reports/profit-summary',
    profit_detail: '/reports/profit-detail',
    customer_quotes: '/reports/customer-quotes',
    supplier_orders: '/reports/supplier-orders',
    supplier_purchases_summary: '/reports/supplier-purchases/summary',
    customer_sales_orders: '/reports/customer-sales-orders',
    customer_delivery_orders: '/reports/customer-delivery-orders',
    sst_02: '/reports/sst-02',
    sst_payment_collection: '/reports/sst-payment-collection',
    sst_deemed_payments: '/reports/sst-deemed-payments',
    sst_recovered_payments: '/reports/sst-recovered-payments',
    sst_by_products: '/reports/sst-by-products',
    sst_sales_detail: '/reports/sst-sales-detail',
    sst_purchase_detail: '/reports/sst-purchase-detail',
    fixed_assets: '/reports/fixed-assets',
    depreciation_schedule: '/reports/depreciation-schedule',
    disposal_schedule: '/reports/disposal-schedule',
    financial_summary: '/reports/financial-summary',
    foreign_exchange_summary: '/reports/foreign-exchange-summary',
    // foreign_exchange_detail: '/reports/foreign-exchange-detail',
    unrealised_exchange_detail: '/reports/unrealised-exchange-detail',
    exchange_rates: '/reports/exchange-rates',
    transaction_list: '/reports/transaction-list',
    audit_trail: '/reports/audit-trails',
    payment_voucher_summary: '/reports/payment-voucher/summary',
    official_receipt_summary: '/reports/official-receipt/summary',
    cash_sales_summary: '/reports/cash-sales/summary',
    cash_purchase_summary: '/reports/cash-purchase/summary',
    journal_entry_detail: '/reports/journal-entry-detail',
    double_entry_detail: '/reports/double-entry-detail',
    chart_of_accounts: '/reports/chart-of-accounts',
};
